import { render, staticRenderFns } from "./lclsBPRC.vue?vue&type=template&id=2672b775&scoped=true"
import script from "./lclsBPRC.vue?vue&type=script&lang=js"
export * from "./lclsBPRC.vue?vue&type=script&lang=js"
import style0 from "./lclsBPRC.vue?vue&type=style&index=0&id=2672b775&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672b775",
  null
  
)

export default component.exports